import React, { useState, useCallback, useEffect } from "react";
import { Box, TextField, MenuItem, Button, Grid, Select } from "@mui/material";
import productApi from "../../../../../services/product";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "../../../../../redux/loader/actions";
import _ from "lodash";
import moment from "moment";

const statuses = ["upcoming", "completed", "ongoing", "stop", "cancel"];
const PlanHistoryFilter = ({
  open,
  searchparams,
  setSearchparams,
  fetchPricing,
  paginationModel,
  setPaginationModel,
  setPlanDetails,
  setManageMode,
  setPriceData,
  setInitialPricingData,
  setPlanName,
  setShowProductPrice,
  resetFields,
  setNoData,
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState("");
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [selectedProductUUID, setSelectedProductUUID] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const handleFilter = () => {
    const logData = {
      product_uuid: selectedProductUUID,
      from: fromDate
        ? moment.utc(fromDate).startOf("day").format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
      to: toDate
        ? moment.utc(toDate).endOf("day").format("YYYY-MM-DD[T]HH:mm:ss[Z]")
        : null,
      package_status: status,
    };

    const filteredLogData = _.pickBy(
      logData,
      (value) => !_.isNil(value) && value !== false && value !== ""
    );

    setSearchparams(filteredLogData);
    setNoData(false);
  };

  const handleReset = () => {
    setFromDate(null);
    setToDate(null);
    setStatus("");
    setSelectedProduct("");
    setSelectedProductUUID("");
    setSearchparams(null);
    // fetchPricing();
    productSelect();
    setPaginationModel({ page: 0, pageSize: 10 });
    setShowProductPrice(false);
    setNoData(true);
  };

  const productSelect = useCallback(() => {
    dispatch(showLoader());

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setProductList(res?.data?.data);
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Error response:", err);
    };

    productApi.getAllProduct().then(onSuccess).catch(onFailure);
  }, [dispatch]);

  useEffect(() => {
    // setFromDate(null);
    // setToDate(null);
    // setStatus("");
    // setSelectedProduct("");
    // setSelectedProductUUID("");
    // setSearchparams();
    // fetchPricing();
    productSelect();
  }, [productSelect]);

  const handleProductChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedProduct(selectedValue);

    const selectedProductItem = productList.find(
      (product) => product.name === selectedValue
    );

    if (selectedProductItem) {
      setSelectedProductUUID(selectedProductItem.uuid);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        alignItems: "center",
        marginBottom: 2,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={3}>
          <Select
            value={selectedProduct}
            onChange={handleProductChange}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Select a product
            </MenuItem>
            {productList.map((product) => (
              <MenuItem key={product.uuid} value={product.name}>
                {product.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <TextField
              id="outlined-basic"
              value={fromDate ? moment(fromDate).format("YYYY-MM-DD") : ""}
              onChange={(e) => {
                setFromDate(e.target.value);
              }}
              label="From Date"
              variant="outlined"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <TextField
              id="outlined-basic"
              value={toDate ? moment(toDate).format("YYYY-MM-DD") : ""}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
              label="To Date"
              variant="outlined"
              type="date"
              inputProps={{
                min: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <TextField
            select
            label="Status"
            value={status}
            fullWidth
            onChange={(e) => setStatus(e.target.value)}
          >
            {statuses.map((option) => (
              <MenuItem key={option} value={option}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFilter}
          sx={{ height: "fit-content" }}
        >
          Search
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleReset}
          sx={{ height: "fit-content" }}
        >
          Reset
        </Button>
      </Box>
    </Box>
  );
};

export default PlanHistoryFilter;
